import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/layouts/DashboardLayout';
import { getDashboard } from '../../components/actions/auth';
import { getCustomer } from '../../components/actions/campaign';
import { getDate } from '../../components/utils/helper';
import Loader from '../../components/utils/Loader';
export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [timeRange, setTimeRange] = useState('7d');
  const [selectedYear, setSelectedYear] = useState('2024');
  const [campaignMetric, setCampaignMetric] = useState('earned');
  const [isTopCustomersModalOpen, setIsTopCustomersModalOpen] = useState(false);
  const [isRecentActivityModalOpen, setIsRecentActivityModalOpen] = useState(false);
   const transactionData = [
     { month: 'Jan', transactions: 4800, points: 150000 },
    { month: 'Feb', transactions: 3200, points: 160000 },
    { month: 'Mar', transactions: 3800, points: 140000 },
    { month: 'Apr', transactions: 3500, points: 175000 },
    { month: 'May', transactions: 3000, points: 200000 },
    { month: 'Jun', transactions: 3600, points: 190000 },
    { month: 'Jul', transactions: 3400, points: 210000 },
  ];

  // Sample monthly points data by year
  const monthlyPointsData = {
    '2024': [
      { month: 'Jan', points: 200000 },
      { month: 'Feb', points: 220000 },
      { month: 'Mar', points: 210000 },
      { month: 'Apr', points: 230000 },
      { month: 'May', points: 250000 },
      { month: 'Jun', points: 240000 },
      { month: 'Jul', points: 260000 },
      { month: 'Aug', points: 270000 },
      { month: 'Sep', points: 280000 },
      { month: 'Oct', points: 0 },
      { month: 'Nov', points: 0 },
      { month: 'Dec', points: 0 },
    ],
    '2023': [
      { month: 'Jan', points: 180000 },
      { month: 'Feb', points: 190000 },
      { month: 'Mar', points: 200000 },
      { month: 'Apr', points: 210000 },
      { month: 'May', points: 220000 },
      { month: 'Jun', points: 230000 },
      { month: 'Jul', points: 240000 },
      { month: 'Aug', points: 250000 },
      { month: 'Sep', points: 260000 },
      { month: 'Oct', points: 270000 },
      { month: 'Nov', points: 280000 },
      { month: 'Dec', points: 290000 },
    ],
  };


  const maxTransaction = Math.max(...transactionData.map((d) => d.transactions));
  const maxPoints = Math.max(...transactionData.map((d) => d.points));
  const maxYearlyPoints = Math.max(
    ...monthlyPointsData[selectedYear].map((d) => d.points)
  );
  useEffect(() => {
    const merchantCode = sessionStorage.getItem('code');
    setLoading(true);

    Promise.all([getDashboard(merchantCode), getCustomer(merchantCode)])
      .then(([dashboardRes, customerRes]) => {
        setResponse(dashboardRes?.data || {});
        setCustomerData(customerRes?.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setResponse({});
        setCustomerData([]);
        setLoading(false);
      });
  }, []);


  // const transactionData = response?.transactionDataforGraph || [];
  const balanceData = response?.totalbalanceWithDuration || [];
  const topCustomers = response?.letestCustomerDetails || [];
  const recentTransactions = response?.transactionData || [];

  const getCustomerName = (customerId) => {
    const customer = customerData.find((cust) => cust.customer_id === customerId);
    return customer ? customer.name : 'Unknown';
  };

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];



  // Stats for the grid
  const stats = [
    {
      title: 'Total Customers',
      value: response?.totalCustomers?.[0]?.totalcustomer || 0,
      change: '+12.5%',
      trend: 'up',
      icon: 'ri-user-line',
      color: 'bg-gradient-to-r from-blue-500 to-blue-600',
    },
    //   {
    //   title: 'Total Transactions',
    //   value: '4,623',
    //   change: '+8.2%',
    //   trend: 'up',
    //   icon: 'ri-exchange-line',
    //   color: 'bg-gradient-to-r from-green-500 to-green-600',
    // },
    {
      title: 'Total Points Earned',
      value: response?.totalbalance?.find((item) => item.tranType === 'earned')?.totalpoint || 0,
      change: '+15.3%',
      trend: 'up',
      icon: 'ri-star-line',
      color: 'bg-gradient-to-r from-yellow-500 to-yellow-600',
    },
    {
      title: 'Total Points Redeemed',
      value: response?.totalbalance?.find((item) => item.tranType === 'earned')?.RedeemValue || 0,
      change: '+6.7%',
      trend: 'up',
      icon: 'ri-gift-line',
      color: 'bg-gradient-to-r from-purple-500 to-purple-600',
    },
    {
      title: 'Active Campaigns',
      value: response?.totalCampaign?.[0]?.totalcampaign || 0,
      change: '+3',
      trend: 'up',
      icon: 'ri-megaphone-line',
      color: 'bg-gradient-to-r from-red-500 to-red-600',
    },
  ];

  const getLevelColor = (level) => {
    switch (level) {
      case 'Platinum':
        return 'bg-gray-800 text-white';
      case 'Gold':
        return 'bg-yellow-500 text-white';
      case 'Silver':
        return 'bg-gray-400 text-white';
      default:
        return 'bg-blue-500 text-white';
    }
  };

  return (
    <DashboardLayout>
      {loading && <Loader />}
      <div className="p-6 space-y-8 bg-gray-50 min-h-screen">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
            <p className="text-gray-600 mt-1">
              Welcome back! Here's your loyalty program performance overview.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <select
              value={timeRange}
              onChange={(e) => setTimeRange(e.target.value)}
              className="px-4 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer bg-white shadow-sm"
            >
              <option value="7d">Last 7 days</option>
              <option value="30d">Last 30 days</option>
              <option value="90d">Last 3 months</option>
              <option value="1y">Last year</option>
            </select>
            <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-sm">
              <i className="ri-download-line"></i>
              Export
            </button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between mb-4">
                <div
                  className={`w-12 h-12 rounded-xl ${stat.color} flex items-center justify-center shadow-lg`}
                >
                  <i className={`${stat.icon} text-xl text-white`}></i>
                </div>
                <span
                  className={`text-sm font-semibold px-2 py-1 rounded-full ${stat.trend === 'up'
                      ? 'text-green-700 bg-green-100'
                      : 'text-red-700 bg-red-100'
                    }`}
                >
                  {stat.change}
                </span>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-1">{stat.value.toLocaleString()}</h3>
                <p className="text-gray-600 text-sm">{stat.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
          {/* Campaign Performance Chart */}
          <div className="xl:col-span-2 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">
                Transaction & Points Analytics
              </h2>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">Transactions</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">Points Earned</span>
                </div>
              </div>
            </div>

            <div className="h-80 bg-gradient-to-t from-gray-50 to-white rounded-lg border border-gray-100 p-6">
              <div className="flex items-end justify-between h-full">
                {transactionData.map((data, index) => (
                  <div key={index} className="flex flex-col items-center gap-2 flex-1">
                    <div className="flex flex-col items-center gap-1 h-full justify-end">
                      {/* Transactions Bar */}
                      <div
                        className="w-8 bg-gradient-to-t from-blue-500 to-blue-400 rounded-t-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer relative group"
                        style={{ height: `${(data.transactions / maxTransaction) * 150}px` }}
                      >
                        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-3 py-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
                          <div className="text-center">
                            <div className="font-semibold">{data.transactions.toLocaleString()}</div>
                            <div className="text-gray-300">Transactions</div>
                          </div>
                        </div>
                      </div>

                      {/* Points Bar */}
                      <div
                        className="w-8 bg-gradient-to-t from-green-500 to-green-400 rounded-t-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer relative group"
                        style={{ height: `${(data.points / maxPoints) * 120}px` }}
                      >
                        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-3 py-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
                          <div className="text-center">
                            <div className="font-semibold">{data.points.toLocaleString()}</div>
                            <div className="text-gray-300">Points</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="text-xs text-gray-600 font-medium">{data.month}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Top Customers */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">Top Customers</h2>
              <button
                onClick={() => setIsTopCustomersModalOpen(true)}
                className="text-blue-600 hover:text-blue-700 text-sm font-medium cursor-pointer"
              >
                View All
              </button>
            </div>
            <div className="space-y-4">
              {topCustomers.length > 0 ? (
                topCustomers.slice(0, 5).map((customer, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-3 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    <div className="relative">
                      <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-semibold shadow-lg">
                        {getCustomerName(customer?.customerid)
                          ?.split(' ')
                          .map((n) => n[0])
                          .join('')}
                      </div>
                      <div className="absolute -top-1 -right-1 w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
                        {index + 1}
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <p className="text-sm font-semibold text-gray-900 truncate">
                          {getCustomerName(customer?.customerid)}
                        </p>
                        <span
                          className={`text-xs px-2 py-1 rounded-full ${getLevelColor(
                            customer.level || 'Silver'
                          )}`}
                        >
                          {customer.level || 'Silver'}
                        </span>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-xs text-gray-500">
                          {customer.earningvalue?.toLocaleString()} points
                        </p>
                        <span className="text-xs text-green-600 font-medium">
                          {customer.growth || ''}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500">No top customers available</p>
              )}
            </div>
          </div>
        </div>

        {/* Monthly Points Earned & Recent Activity */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
          {/* Monthly Points Earned by Year */}
           <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">
                Monthly Points Earned
              </h2>
              <div className="flex items-center gap-4">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent cursor-pointer bg-white text-sm"
                >
                  <option value="2024">2024</option>
                  <option value="2023">2023</option>
                </select>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">Points Earned</span>
                </div>
              </div>
            </div>

            <div className="h-64 bg-gradient-to-t from-purple-50 to-white rounded-lg border border-gray-100 p-4">
              <div className="flex items-end justify-between h-full">
                {monthlyPointsData[selectedYear].map((data, index) => (
                  <div key={index} className="flex flex-col items-center gap-2 flex-1">
                    <div
                      className="w-6 bg-gradient-to-t from-purple-600 to-purple-400 rounded-t-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer relative group"
                      style={{
                        height: `${
                          data.points ? (data.points / maxYearlyPoints) * 200 : 10
                        }px`,
                      }}
                    >
                      {data.points > 0 && (
                        <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-3 py-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
                          <div className="text-center">
                            <div className="font-semibold">{data.points.toLocaleString()}</div>
                            <div className="text-gray-300">Points</div>
                          </div>
                        </div>
                      )}
                    </div>
                    <span className="text-xs text-gray-600 font-medium">{data.month}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-900">Recent Activity</h2>
              <button
                onClick={() => setIsRecentActivityModalOpen(true)}
                className="text-blue-600 hover:text-blue-700 text-sm font-medium cursor-pointer"
              >
                View All
              </button>
            </div>
            <div className="space-y-4 max-h-64 overflow-y-auto">
              {recentTransactions.length > 0 ? (
                recentTransactions.slice(0, 5).map((activity, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-4 p-3 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center text-green-600 bg-green-50 shadow-sm"
                    >
                      <i className="ri-add-circle-line text-lg"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-gray-900 mb-1">
                        <span className="font-semibold">{getCustomerName(activity?.customerid)}</span> earned {activity?.earningvalue} points
                      </p>
                      <div className="flex items-center justify-between">
                        <p className="text-xs text-gray-500">{getDate(activity?.createdAt, 'DD-MMM-YYYY')}</p>
                        <span className="text-xs font-semibold text-gray-700">
                          {activity?.earningvalue} points
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500">No transactions available</p>
              )}
            </div>
          </div>
        </div>

        {/* Top Customers Modal */}
        {isTopCustomersModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-900">All Top Customers</h2>
                <button
                  onClick={() => setIsTopCustomersModalOpen(false)}
                  className="text-gray-600 hover:text-gray-800 font-medium"
                >
                  Close
                </button>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full table-auto border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Rank</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Name</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Points</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Level</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Growth</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topCustomers.length > 0 ? (
                      topCustomers.map((customer, index) => (
                        <tr key={index} className="border-b hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">{index + 1}</td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {getCustomerName(customer?.customerid)}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {customer.earningvalue?.toLocaleString()} points
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <span
                              className={`inline-block px-2 py-1 rounded-full ${getLevelColor(
                                customer.level || 'Silver'
                              )}`}
                            >
                              {customer.level || 'Silver'}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-green-600">
                            {customer.growth || '+0%'}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="px-4 py-3 text-center text-gray-500">
                          No top customers available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Recent Activity Modal */}
        {isRecentActivityModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-semibold text-gray-900">All Recent Activity</h2>
                <button
                  onClick={() => setIsRecentActivityModalOpen(false)}
                  className="text-gray-600 hover:text-gray-800 font-medium"
                >
                  Close
                </button>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full table-auto border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Customer</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Action</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Points</th>
                      <th className="px-4 py-2 text-left text-sm font-semibold text-gray-900">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentTransactions.length > 0 ? (
                      recentTransactions.map((activity, index) => (
                        <tr key={index} className="border-b hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {getCustomerName(activity?.customerid)}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            Earned {activity?.earningvalue} points
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {activity?.earningvalue} points
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {getDate(activity?.createdAt, 'DD-MMM-YYYY')}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="px-4 py-3 text-center text-gray-500">
                          No transactions available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          
          </div>
        )}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-6">Performance Metrics</h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg">
                  <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-user-heart-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">87.5%</h3>
                  <p className="text-sm text-gray-600">Customer Retention</p>
                </div>

                <div className="text-center p-4 bg-gradient-to-br from-green-50 to-green-100 rounded-lg">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-line-chart-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">142.3%</h3>
                  <p className="text-sm text-gray-600">Engagement Growth</p>
                </div>

                <div className="text-center p-4 bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg">
                  <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-trophy-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">95.2%</h3>
                  <p className="text-sm text-gray-600">Campaign Success</p>
                </div>

                <div className="text-center p-4 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg">
                  <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">$2.4M</h3>
                  <p className="text-sm text-gray-600">Revenue Impact</p>
                </div>
              </div>
            </div>
      </div>
    </DashboardLayout>
  );
}